export default "__VITE_ASSET__CNz91_H9__"